/* eslint-disable react/no-unused-prop-types */

import './LocationMapChart.scss';

import * as olControl from 'ol/control';
import * as olInteraction from 'ol/interaction';
import * as olProj from 'ol/proj';

import React, { Component } from 'react';

import { AVIMapTile } from '../Layout/AVIMapTile';
import { DcExtLocationMapChart } from '../DcExt/DcExtLocationMapChart';
import { LayerSwitcherMixin } from '../Mixins/LayerSwitcherMixin';
import Map from 'ol/Map';
import PropTypes from 'prop-types';
import { SimpleBaseMixin } from '../Mixins/SimpleBaseMixin';
import olView from 'ol/View';

export class LocationMapChart extends Component {
  static propTypes = {
    geoJson: PropTypes.object.isRequired,
    geoJsonHighlight: PropTypes.object,
    chartTitle: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
    geoJsonKey: PropTypes.string,
    geoJsonHighlightKey: PropTypes.string,
    useFlex: PropTypes.bool
  };

  static defaultProps = {
    geoJsonKey: null,
    geoJsonHighlightKey: null,
    useFlex: false
  };

  map = null;

  constructor (props) {
    super(props);
    this.chartRef = React.createRef();
    this.chart = null;
    this.getMap = this.getMap.bind(this);
  }

  componentDidMount () {
    const { geoJson, geoJsonHighlight } = this.props;

    var zoomPt = [15, 61];

    this.map = new Map({
      target: this.chartRef.current,
      interactions: olInteraction.defaults({ mouseWheelZoom: false }),
      controls: olControl.defaults({
        attributionOptions: {
          collapsible: false
        }
      }),
      view: new olView({
        center: olProj.transform([zoomPt[0], zoomPt[1]], 'EPSG:4326', 'EPSG:3857'),
        zoom: 5
      })
    });

    this.chart = new DcExtLocationMapChart({
      map: this.map
    });

    SimpleBaseMixin(this.chart, this.props);

    this.chart.geoJson(geoJson);
    if (geoJsonHighlight !== undefined) {
      this.chart.geoJsonHighlight(geoJsonHighlight);
    }

    LayerSwitcherMixin(this.map);
    this.chart.render();
  }

  getMap () {
    return this.map;
  }

  render () {
    const {chartTitle, height, width, useFlex} = this.props;
    return (
      <AVIMapTile
        title={chartTitle}
        height={height}
        width={width}
        getMap={this.getMap}
        useFlex={useFlex}
      >
        <div className='avi-map' ref={this.chartRef} />
      </AVIMapTile>
    );
  }
}
